<div class="container">
  <h1 class="customer-register">{{'common.register_customer_regisration'|cxTranslate}}</h1>
  <div class="create-account-text">{{'common.guest_register'|cxTranslate}}</div>
  <div class="form-container register-form-container">
    <div class="register-form">

      <p class="title">{{'common.register_site_description'|cxTranslate}}</p>
      <p class="req-info-text">{{'common.register_site_company'|cxTranslate}}</p>
    </div>
    <div class="form-field-control register-form-control">
      <div class="row mt-3">
        <div class="col register-col">
          <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
            @if (pageFieldData) {
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 industryRole">
                <label for="email" class="control-label">{{'common.register_site_companyrole'|cxTranslate}}</label>
                @for (roleList of filteredIndustryRoles; track roleList; let i = $index) {
                  <div class="form-check" [ngClass]="{ 'is-invalid': !selectedIndustryRole && submitted}"
                    >
                    <input class="form-check-input" [id]="" (change)="selectIndustryRole($event)" type="radio"
                      [value]="roleList.code" [id]="'test'+i" name="industryRole">
                      <label class="form-check-label " for="distributor">
                        {{roleList.name}}
                      </label>
                    </div>
                  }
                  <div class="invalid-feedback">
                    @if (!selectedIndustryRole && submitted) {
                      <span class="text-danger-show"
                      >{{'common.register_company_industryRole_invalid'|cxTranslate}}</span>
                    }
                  </div>
                </div>
              }
              <!-- email address -->
              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <label for="email" class="control-label">{{'common.register_email_mandatory'|cxTranslate}}</label>
                <input type="email" (blur)="checkExistingEmailAddress()" class="form-control" formControlName="email"
                  [ngClass]="{ 'is-valid': (f.email.dirty || submitted) && !f.email.errors, 'is-invalid': (f.email.dirty || submitted) && f.email.errors }" />
                  <div class="invalid-feedback">
                    @if ( f['email']?.errors && f['email']?.errors['required']) {
                      <span class="text-danger-show"
                      >{{'common.register_email_invalid'|cxTranslate}}</span>
                    }
                    @if ( f['email']?.errors && f['email']?.errors['email']) {
                      <span class="text-danger-show"
                      >{{'common.register_email_invalid'|cxTranslate}}</span>
                    }
                  </div>
                  @if (isUserAlreadyRegistered?.length>0) {
                    <span class="text-danger-show"
                    >{{isUserAlreadyRegistered|cxTranslate}}</span>
                  }
                </div>

                <!-- password -->
                <div class="d-flex flex-sm-row flex-column">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 reg-password-block">
                    <label for="password" class="control-label">{{'common.register_pwd'|cxTranslate}}</label>
                    <input type="password" formControlName="password" class="form-control" name="password"
                      [ngClass]="{ 'is-valid': (f.password.dirty || submitted) && passwordValid, 'is-invalid': (f.password.dirty || submitted) && !passwordValid }" />
                      <div class="invalid-feedback">
                        <!-- required -->
                        <!-- <span class="text-danger-show" *ngIf="(f.password.dirty || submitted) && !requiredValid">Password is required</span> -->

                        <!-- password validation rules -->
                        @if (requiredValid) {
                          <div id="validation-rules" class="mt-1">
                            <p>{{'common.secure_update_pwd_doesnot_meetReq_msg'|cxTranslate}}</p>
                            <div class="password-error-block">
                              <!-- minlength -->
                              <div [ngClass]="{ 'text-success': minLengthValid, 'text-danger': !minLengthValid }">
                                <img [attr.src]="minLengthValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'" alt=""
                                  class="icon-right">
                                  {{'common.secure_update_pwd_validation_msg1'|cxTranslate}}
                                </div>
                                <!-- requires digit -->
                                <div [ngClass]="{ 'text-success': requiresDigitValid, 'text-danger': !requiresDigitValid }">
                                  <img [attr.src]="requiresDigitValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                    alt="" class="icon-right">
                                    {{'common.secure_update_pwd_validation_msg4'|cxTranslate}}
                                  </div>
                                  <!-- requires uppercase -->
                                  <div
                                    [ngClass]="{ 'text-success': requiresUppercaseValid, 'text-danger': !requiresUppercaseValid }">
                                    <img [attr.src]="requiresUppercaseValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                      alt="" class="icon-right">
                                      {{'common.secure_update_pwd_validation_msg3'|cxTranslate}}
                                    </div>
                                    <!-- requires lowercase -->
                                    <div
                                      [ngClass]="{ 'text-success': requiresLowercaseValid, 'text-danger': !requiresLowercaseValid }">
                                      <img [attr.src]="requiresLowercaseValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                        alt="" class="icon-right">
                                        {{'common.secure_update_pwd_validation_msg2'|cxTranslate}}
                                      </div>
                                      <!-- requires special characters -->
                                      <div
                                        [ngClass]="{ 'text-success': requiresSpecialCharsValid, 'text-danger': !requiresSpecialCharsValid }">
                                        <img
                                          [attr.src]="requiresSpecialCharsValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                          alt="" class="icon-right">
                                          {{'common.secure_update_pwd_validation_msg5'|cxTranslate}}
                                        </div>
                                        <p>{{'common.secure_update_pwd_personalInfo_msg'|cxTranslate}}</p>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>

                              <!-- confirm password -->
                              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 reg-confirmPassword">
                                <label for="confirmPassword" class="control-label">{{'common.register_checkPwd'|cxTranslate}}</label>
                                <input type="password" formControlName="confirmPassword" class="form-control" name="confirmPassword"
                                  [ngClass]="{ 'is-valid': (submitted || f.confirmPassword.dirty) && !f.confirmPassword.errors, 'is-invalid': (submitted || f.confirmPassword.dirty) && f.confirmPassword.errors }">
                                  @if ((submitted || f.confirmPassword.dirty) && f.confirmPassword.errors) {
                                    <div class="invalid-feedback"
                                      >
                                      @if (f['confirmPassword'].errors['required']) {
                                        <div class="text-danger-show">
                                        {{'common.register_checkPwd_invalid'|cxTranslate}}</div>
                                      }
                                      @if (f['confirmPassword'].errors['minLength']) {
                                        <div class="text-danger-show">
                                        {{'common.register_checkPwd_invalid'|cxTranslate}}</div>
                                      }
                                      @if (f['confirmPassword'].errors['mismatch']) {
                                        <div>
                                        {{'common.register_password_not_match'|cxTranslate}}</div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <!--Title-->
                              <div>
                                @if (pageFieldData) {
                                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                    <label for="confirmPassword" class="control-label">{{'common.register_title'|cxTranslate}}</label>
                                    <div class="select-box">
                                      <select name="industry" class="form-control" formControlName="title">
                                        <option value=""></option>
                                        @for (item of pageFieldData.titlesWSList; track item) {
                                          <option [value]="item.code">{{item.name}}</option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                }

                              </div>
                              <!--First Name-->
                              <div class="d-flex flex-sm-row flex-column">
                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                  <label for="firstName" class="control-label">{{'common.register_firstName'|cxTranslate}}</label>
                                  <input type="text" formControlName="firstName" class="form-control"
                                    [ngClass]="{ 'is-valid': (f.firstName.dirty || submitted) && !f.firstName.errors, 'is-invalid': (f.firstName.dirty || submitted) && f.firstName.errors }"
                                    name="firstName">
                                    <div class="invalid-feedback">
                                      @if ( f['firstName']?.errors && f['firstName']?.errors['required']) {
                                        <span class="text-danger-show"
                                        >{{'common.register_firstName_invalid'|cxTranslate}}</span>
                                      }
                                    </div>
                                  </div>
                                  <!--Last Name-->
                                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                    <label for="lastName" class="control-label">{{'common.register_lastName'|cxTranslate}}</label>
                                    <input type="text" formControlName="lastName" class="form-control" name="lastName"
                                      [ngClass]="{ 'is-valid': (f.lastName.dirty || submitted) && !f.lastName.errors, 'is-invalid': (f.lastName.dirty || submitted) && f.lastName.errors }">
                                      <div class="invalid-feedback">
                                        @if ( f['lastName']?.errors && f['lastName']?.errors['required']) {
                                          <span class="text-danger-show"
                                          >{{'common.register_lastName_invalid'|cxTranslate}}</span>
                                        }
                                      </div>
                                    </div>

                                  </div>

                                  <!--Requesting Access-->
                                  @if (pageFieldData) {
                                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 requestAccess">
                                      <label for="email"
                                      class="control-label regform-subtitle">{{'common.register_company_accessRequesting'|cxTranslate}}</label>
                                      @for (requestAccess of accessRequestsWSList; track requestAccess) {
                                        <div class="form-check"
                                          [ngClass]="{ 'is-invalid': selectedRequestAccess.length==0 && submitted}">
                                          <input class="form-check-input" (click)="selectRequestAccess($event)" [value]="requestAccess.code"
                                            type="checkbox" formControlName="requestAccessFor">
                                            <label class="form-check-label" for="distributor">
                                              {{requestAccess.name}}
                                            </label>
                                          </div>
                                        }
                                        <div>
                                          @if (selectedRequestAccess.length==0 && submitted) {
                                            <span class="text-danger-show"
                                            >{{'common.register_company_accessRequesting_invalid'|cxTranslate}}</span>
                                          }
                                        </div>
                                      </div>
                                    }

                                    <!--Company Name-->
                                    <div class="d-flex flex-sm-row flex-column">
                                      <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                        <label for="companyName" class="control-label">{{'common.register_company_name'|cxTranslate}}</label>
                                        <input type="text" formControlName="companyName" class="form-control" name="companyName"
                                          [ngClass]="{ 'is-valid': (f.companyName.dirty || submitted) && !f.companyName.errors, 'is-invalid': (f.companyName.dirty || submitted) && f.companyName.errors }">
                                          <div class="invalid-feedback">
                                            @if ( f['companyName']?.errors && f['companyName']?.errors['required']) {
                                              <span class="text-danger-show"
                                              >{{'common.register_company_name_invalid'|cxTranslate}}</span>
                                            }
                                          </div>
                                        </div>
                                        <!--Sold To-->
                                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                          <label for="soldTo"
                                            class="control-label d-flex align-items-center">{{'common.register_company_soldto'|cxTranslate}}
                                            {{'common.login_optional'|cxTranslate}}
                                            <img src="images/question.svg" class="question-icon" (click)="openSoldToInfoDialog()"
                                              alt="Open Sold to Info">
                                            </label>
                                            <input type="text" formControlName="soldTo" class="form-control" name="soldTo">
                                          </div>
                                        </div>

                                        <!--Address1-->
                                        <div class="d-flex flex-sm-row flex-column">
                                          <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                            <label for="address1"
                                            class="control-label">{{'common.register_company_address_street'|cxTranslate}}</label>
                                            <input type="text" formControlName="address1" class="form-control" name="address1"
                                              [ngClass]="{ 'is-valid': (f.address1.dirty || submitted) && !f.address1.errors, 'is-invalid': (f.address1.dirty || submitted) && f.address1.errors }">
                                              <div class="invalid-feedback">
                                                @if ( f['address1']?.errors && f['address1']?.errors['required']) {
                                                  <span class="text-danger-show"
                                                  >{{'common.register_company_address_street_invalid'|cxTranslate}}</span>
                                                }
                                              </div>
                                            </div>
                                            <!--Address2-->
                                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                              <label for="address2"
                                              class="control-label">{{'common.register_company_address_two'|cxTranslate}}</label>
                                              <input type="text" formControlName="address2" class="form-control" name="address2">
                                            </div>
                                          </div>

                                          <!--City-->
                                          <div class="d-flex flex-sm-row flex-column">
                                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                              <label for="city" class="control-label">{{'common.register_company_address_city'|cxTranslate}}</label>
                                              <input type="text" formControlName="city" class="form-control" name="city"
                                                [ngClass]="{ 'is-valid': (f.city.dirty || submitted) && !f.city.errors, 'is-invalid': (f.city.dirty || submitted) && f.city.errors }">
                                                <div class="invalid-feedback">
                                                  @if ( f['city']?.errors && f['city']?.errors['required']) {
                                                    <span class="text-danger-show"
                                                    >{{'common.register_company_address_city_invalid'|cxTranslate}}</span>
                                                  }
                                                </div>
                                              </div>
                                              <!--Zip-->
                                              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                <label for="zip" class="control-label">{{'common.register_company_address_zip'|cxTranslate}}</label>
                                                <input type="text" maxlength="15" formControlName="zip" class="form-control" name="zip"
                                                  [ngClass]="{ 'is-valid': (f.zip.dirty || submitted) && !f.zip.errors, 'is-invalid': (f.zip.dirty || submitted) && f.zip.errors }">
                                                  <div class="invalid-feedback">
                                                    @if ( f['zip']?.errors && f['zip']?.errors['required']) {
                                                      <span class="text-danger-show"
                                                      >{{'common.register_company_address_zip_invalid'|cxTranslate}}</span>
                                                    }
                                                  </div>
                                                </div>
                                              </div>

                                              <!--Country-->
                                              <div class="d-flex flex-sm-row flex-column">
                                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  @if ((pageFieldData$|async); as pageFieldData) {
                                                    <label for="country"
                                                    class="control-label">{{'common.register_company_countryCode'|cxTranslate}}</label>
                                                    <div class="select-box">
                                                      <select name="country" class="form-control" formControlName="country"
                                                        (change)="onCountryChange($event)"
                                                        [ngClass]="{ 'is-valid': (f.country.dirty || submitted) && !f.country.errors, 'is-invalid': (f.country.dirty || submitted) && f.country.errors }">
                                                        <option value="null" disabled selected>{{'common.form_register_empty'|cxTranslate}}</option>
                                                        @for (item of pageFieldData['countriesWSList']; track item) {
                                                          <option [value]="item.isocode">{{item.name}}
                                                          </option>
                                                        }
                                                      </select>
                                                      <div class="invalid-feedback">
                                                        @if ( f['country']?.errors && f['country']?.errors['required']) {
                                                          <span class="text-danger-show"
                                                          >{{'common.register_company_countryCode_invalid'|cxTranslate}}</span>
                                                        }
                                                      </div>
                                                    </div>
                                                  }

                                                </div>
                                                <!--State-->
                                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  @if (baseSite !=='APAC') {
                                                    <label for="state"
                                                    class="control-label">{{'common.register_company_companyStateCode'|cxTranslate}}</label>
                                                  }
                                                  @if (baseSite ==='APAC') {
                                                    <label for="state"
                                                    class="control-label">{{'common.register_company_companyStateCode_japan'|cxTranslate}}</label>
                                                  }
                                                  <div class="select-box">
                                                    <select name="state" class="form-control" formControlName="state"
                                                      [ngClass]="{ 'is-valid': (f.state.dirty || submitted) && !f.state.errors, 'is-invalid': (f.state.dirty || submitted) && f.state.errors }">
                                                      <option value="null" disabled selected>{{'common.register_state_placeholder'|cxTranslate}}</option>
                                                      @for (item of stateList?.regionsWSList; track item) {
                                                        <option [value]="item.isocode">{{item.name}}</option>
                                                      }
                                                    </select>
                                                    <div class="invalid-feedback">
                                                      @if ( f['state']?.errors && f['state']?.errors['required']) {
                                                        <span class="text-danger-show">
                                                          @if (baseSite !='APAC') {
                                                            <span
                                                            >{{'common.register_company_companyStateCode_invalid'|cxTranslate}}</span>
                                                          }
                                                          @if (baseSite =='APAC') {
                                                            <span>{{'common.address_prefecture_invalid'|cxTranslate}}</span>
                                                          }
                                                        </span>
                                                      }
                                                    </div>
                                                  </div>

                                                </div>
                                              </div>

                                              <!--Phone-->
                                              <div class="d-flex flex-sm-row flex-column">
                                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  <label for="phone" class="control-label">{{'common.register_company_phoneNumber'|cxTranslate}}</label>
                                                  <input type="text" maxlength="15" formControlName="phone" class="form-control" name="phone">
                                                </div>
                                                <!--Fax-->
                                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  <label for="fax" class="control-label">{{'common.register_company_faxNumber'|cxTranslate}}</label>
                                                  <input type="text" maxlength="15" formControlName="fax" class="form-control" name="fax">
                                                </div>
                                              </div>

                                              <!--website-->
                                              <div class="d-flex flex-sm-row flex-column">
                                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  <label for="website" class="control-label">{{'common.register_company_website'|cxTranslate}}</label>
                                                  <input type="text" formControlName="website" class="form-control" name="website">
                                                </div>
                                                <!--Add sold to-->
                                                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                                  <label for="addSoldTo"
                                                  class="control-label">{{'common.register_company_additionalSoldToLocations'|cxTranslate}}</label>
                                                  <textarea formControlName="addSoldTo" class="form-control soldToLocation" name="addSoldTo"
                                                  [placeholder]="'common.additional_soldto_location_description'|cxTranslate"></textarea>
                                                </div>
                                              </div>

                                              <div class="form-group col-xs-12 col-sm-12">
                                                <div class="form-check generalCondition">
                                                  <input class="form-check-input" formControlName="generalCondition"
                                                    (click)="generalConditionClick($event)" type="checkbox">
                                                    <label class="form-check-label">
                                                      {{'common.register_dataprotection_acceptNA'|cxTranslate}} <a
                                                    (click)="openGeneralConditionDialog()">{{'common.register_terms_condition'|cxTranslate}}</a>
                                                  </label>
                                                  <div class="">
                                                    @if (submitted && signupForm.controls['generalCondition'].value !==true) {
                                                      <span class="text-danger"
                                                      >{{'common.register_termsOfUsage_accept_invalid'|cxTranslate}}</span>
                                                    }
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="form-group col-xs-12 col-sm-12">
                                                <div class="form-check dataProtection">
                                                  <input class="form-check-input" formControlName="dataProtection" (click)="dataProtectionClick($event)"
                                                    type="checkbox">
                                                    <label class="form-check-label">
                                                      {{'common.register_dataprotection_acceptNA'|cxTranslate}} <a
                                                    (click)="openDataProtectionDialog()">{{'common.register_data-protection'|cxTranslate}}</a>
                                                  </label>
                                                  <div class="">
                                                    @if (submitted && signupForm.controls['dataProtection'].value !==true) {
                                                      <span class="text-danger"
                                                      >{{'common.register_termOfUsage_accept_dataProtection'|cxTranslate}}</span>
                                                    }
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="form-group col-xs-12 col-sm-12">
                                                <re-captcha id="recaptcha" formControlName="recaptcha" (resolved)="checkCaptcha($event)"
                                                  formControlName="recaptcha" name="recaptcha" required
                                                [class.is-invalid]="submitted && !captchaResolved"></re-captcha>
                                                @if (submitted && !captchaResolved) {
                                                  <div class="invalid-feedback">
                                                  {{'common.general_required'|cxTranslate}}.</div>
                                                }
                                              </div>

                                              <!-- submit button -->
                                              <div class="form-group col-xs-12 col-sm-6 col-md-4 submit-btn">
                                                <button type="submit" class="btn btn-block btn-primary create-btn" [disabled]="isWorking">
                                                  <i [attr.class]="isWorking ? 'bi-hourglass-split' : 'bi-check2-square'"></i>
                                                  {{'common.register_new_customer'|cxTranslate}}
                                                  <img src="/icons/link-dark-grey.svg" alt="" class="register-icon-right">
                                                </button>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>